import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { ApplicationsSkeletonComponent } from '../../applications/applications-skeleton/applications-skeleton.component';
import { AssessmentDetailSkeletonComponent } from '../../assessments/assessment-detail-skeleton/assessment-detail-skeleton.component';

@Component({
  selector: 'app-shell-skeleton',
  templateUrl: './app-shell-skeleton.component.html',
  styleUrls: ['./app-shell-skeleton.component.css'],
  imports: [SkeletonComponent, ApplicationsSkeletonComponent, AssessmentDetailSkeletonComponent],
})
export class AppShellSkeletonComponent {
  private router = inject(Router);

  readonly navItems = [1, 2, 3, 4, 5];
  readonly contentCards = [1, 2, 3];

  get pageType(): 'dashboard' | 'applications' | 'assessment' | 'generic' {
    const url = this.router.url;
    if (url.startsWith('/applications')) return 'applications';
    if (url.startsWith('/assessment')) return 'assessment';
    if (url === '/' || url.startsWith('/dashboard')) return 'dashboard';
    return 'generic';
  }
}
